var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserService } from "../../../services/user.service";
import { EduComponent } from "../../../utils/eduComponent";
import Utils from "../../../utils/utils";
var StudentProjectsComponent = /** @class */ (function (_super) {
    __extends(StudentProjectsComponent, _super);
    function StudentProjectsComponent(userService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.newProjectURL = window.PBSLM.NEW_STORYBOARD_URL;
        _this.populationComplete = false;
        _this.displayedCreations = [];
        _this.activeCreations = [];
        _this.creations = [];
        _this.defaultLimit = 5;
        _this.addSub(_this.userService.studentProjects.subscribe(function (projects) {
            _this.creations = projects.slice();
            _this.displayedCreations = _this.creations.slice(0, _this.defaultLimit);
            _this.populationComplete = true;
        }));
        _this.userService.loadStudentProjects();
        return _this;
    }
    StudentProjectsComponent.prototype.isActive = function (code) {
        return this.activeCreations.indexOf(code) > -1;
    };
    StudentProjectsComponent.prototype.toggleActive = function (code) {
        var index = this.activeCreations.indexOf(code);
        if (index > -1) {
            this.activeCreations.splice(index, 1);
        }
        else {
            this.activeCreations.push(code);
        }
    };
    StudentProjectsComponent.prototype.shouldPaginate = function () {
        if (this.defaultLimit != null) {
            return this.creations.length > this.defaultLimit;
        }
    };
    StudentProjectsComponent.prototype.showMore = function () {
        this.defaultLimit += 5;
    };
    StudentProjectsComponent.prototype.copyLinkByElementId = function (elemId) {
        Utils.copyLinkByElementId(elemId);
    };
    return StudentProjectsComponent;
}(EduComponent));
export { StudentProjectsComponent };
